import { render, staticRenderFns } from "./ImpactColumn.vue?vue&type=template&id=31e7cf96"
import script from "./ImpactColumn.vue?vue&type=script&lang=js"
export * from "./ImpactColumn.vue?vue&type=script&lang=js"
import style0 from "./ImpactColumn.vue?vue&type=style&index=0&id=31e7cf96&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports